import { ClockSync } from '@crowdset/domain';

/** Local monotonic-ish clock in epoch ms; immune to wall-clock jumps within a page lifetime. */
export const localNow = (): number => performance.timeOrigin + performance.now();

class ClockService {
  readonly sync = new ClockSync(8, 3);
  /** Rough offset from the last snapshot, used only until ping samples exist. */
  private fallbackOffset: number | null = null;
  private listeners = new Set<() => void>();

  noteServerTime(serverNowMs: number) {
    this.fallbackOffset = serverNowMs - localNow();
  }

  addSample(t0: number, t1: number, serverNowMs: number) {
    this.sync.add({ t0, t1, serverNowMs });
    for (const l of this.listeners) l();
  }

  reset() {
    this.sync.reset();
  }

  get ready(): boolean {
    return this.sync.offsetMs !== null || this.fallbackOffset !== null;
  }

  get quality(): { samples: number; bestRttMs: number | null } {
    return { samples: this.sync.sampleCount, bestRttMs: this.sync.bestRttMs };
  }

  serverNow(): number {
    const o = this.sync.offsetMs ?? this.fallbackOffset ?? 0;
    return localNow() + o;
  }

  subscribe(fn: () => void) {
    this.listeners.add(fn);
    return () => void this.listeners.delete(fn);
  }
}

export const clock = new ClockService();
